/**
 * More granular access rights to specific things in the system
 */
export var AccessRight;
(function (AccessRight) {
    // Platform level permissions
    /**
     * @deprecated
     * Allows the user to log in as a full-access admin to a specific organization
     */
    AccessRight["PlatformLoginAs"] = "PlatformLoginAs";
    /**
     * Create new organizations with at least one of the tags this right was granted for
     */
    AccessRight["PlatformCreateOrganizations"] = "PlatformCreateOrganizations";
    // Organization level permissions
    AccessRight["OrganizationCreateWebshops"] = "OrganizationCreateWebshops";
    AccessRight["OrganizationManagePayments"] = "OrganizationManagePayments";
    AccessRight["OrganizationFinanceDirector"] = "OrganizationFinanceDirector";
    AccessRight["OrganizationCreateGroups"] = "OrganizationCreateGroups";
    AccessRight["EventWrite"] = "EventWrite";
    /** defines that this person can review event notification for this organization. You can limit which events by restricing the organizations the user has access to. */
    AccessRight["OrganizationEventNotificationReviewer"] = "OrganizationEventNotificationReviewer";
    // Member data access rights
    // Note: in order to read or write any data at all, a user first needs to have normal resource access to a group, category or organization
    // So general data (name, birthday, gender, address, email, parents, emergency contacts) access can be controlled in that way (this doesn't have a separate access right).
    AccessRight["MemberReadFinancialData"] = "MemberReadFinancialData";
    AccessRight["MemberWriteFinancialData"] = "MemberWriteFinancialData";
    /**
     * Edit/view national registration number
     */
    AccessRight["MemberManageNRN"] = "MemberManageNRN";
    // Webshop level permissions
    AccessRight["WebshopScanTickets"] = "WebshopScanTickets";
    /**
     * Send messages for a given sender
     */
    AccessRight["SendMessages"] = "SendMessages";
    /**
     * Create, edit and delete email templates
     */
    AccessRight["ManageEmailTemplates"] = "ManageEmailTemplates";
})(AccessRight || (AccessRight = {}));
//# sourceMappingURL=AccessRight.js.map